import React from 'react';

const UseCaseSelector = ({ activeCase, onSelectCase }) => {
  const useCases = [
    { id: 'answers', label: '💬 Quick Answers' },
    { id: 'predict', label: '🔮 Predict Outcomes' },
    { id: 'explain', label: '🔍 Explain Changes' },
    { id: 'simulate', label: '⚡ Simulate Scenarios' },
    { id: 'anomaly', label: '🚨 Detect Anomalies' },
    { id: 'audit', label: '📋 Audit Decisions' },
    { id: 'autonomous', label: '🤖 Autonomous Actions' }
  ];

  return (
    <section id="selector" className="selector-section">
      <div className="container">
        <div className="selector-label">Choose your use case</div>
        <div className="selector-grid">
          {useCases.map((useCase) => (
            <button
              key={useCase.id}
              className={`selector-btn ${activeCase === useCase.id ? 'active' : ''}`}
              onClick={() => onSelectCase(useCase.id)}
            >
              {useCase.label}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCaseSelector;
